import { DefaultButton, IconButton } from 'office-ui-fabric-react';
import React, { Component } from 'react';
import { DataAlarme } from '../../data/DataAlarme';
import { DataMonCompte } from '../../data/DataMonCompte';
import { Immocom } from '../../specifique/immocom';
import { DetailsListAlarme } from '../List/DetailsListAlarme';
import { Modal } from 'office-ui-fabric-react/lib/Modal';
import { mergeStyleSets } from 'office-ui-fabric-react';

//#region CSS
const classNames = mergeStyleSets({
    modalContainer: {
        display: 'flex',
        flexDirection: 'column',
        width: '60vw',
        height: '30vw'
    },
    modalScrollableContent: {
        display: 'flex',
        flexDirection: 'column'
    },
    modalHeader: {
        background: '#fd0400',
        color: 'white',
        padding: '8px 28px 0'
    },
    modalBody: {
        flex: '2 2',
        overflowY: 'auto',
    },
    modalFooter: {
        display: 'flex',
        justifyContent: 'center',
        padding: '15px 28px',
    },
    newsItem: { padding: '5px 0px' },
    newsTitre: { fontWeight: 'bold' },
    newsRecente: {
        color: '#fd0400',
        fontWeight: 'bold'
    }
});
//#endregion

export class ModalAlarmes extends Component {

    constructor(props) {
        super(props);

        this.state = {
            afficherModalAlarmes: false,
        }
    }

    _chargementDroitsLiesAuxAlarmes = () => {
        let chargementDroitsLiesAuxAlarmes = DataMonCompte._chargementDroitsLiesAuxAlarmes();
        chargementDroitsLiesAuxAlarmes
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const droits = responseFetch.reponseAPIobjet;
                    const peutGererAlarmesCapsuleClient = droits.peutGererAlarmesCapsuleClient;
                    this.setState(
                        { peutGererAlarmesCapsuleClient },
                        () => { if (peutGererAlarmesCapsuleClient) this._chargementAlarmes(); }
                    );
                }
                else {
                    const stateTemp = { peutGererAlarmesCapsuleClient: false };
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _chargementAlarmes = () => {
        let chargementAlarmes = DataAlarme._chargementAlarmes({ afficherAlarmesLieesACapsules: true, afficherAlarmesInactives: false });
        chargementAlarmes
            .then(responseFetch => {
                const retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);
                if (retourVerif === null) {
                    const listeAlarmes = responseFetch.reponseAPIobjet;
                    if (listeAlarmes.length > 0) {
                        this.setState({ afficherModalAlarmes: true });
                    }
                }
                else {
                    const stateTemp = { afficherModalAlarmes: false };
                    Immocom.onTraitementErreurAvecState(this, stateTemp, retourVerif, responseFetch);
                }
            });
    };

    _getButtons = () => {
        let buttons = [];
        if (this.state.peutGererAlarmesCapsuleClient)
            buttons.push(<IconButton
                ariaLabel="Afficher les alarmes actives"
                iconProps={{ iconName: "Ringer" }}
                key="alarms"
                onClick={this._toggleModalAlarmes(true)}
                title="Afficher les alarmes"
            />);
        return buttons;
    };

    _toggleModalAlarmes = (isOpen) => () => {
        this.setState({ afficherModalAlarmes: isOpen });
    };

    componentDidMount = () => {
        this._chargementDroitsLiesAuxAlarmes();
    };

    render = () => {
        return <Modal
            isOpen={this.state.afficherModalAlarmes}
            onDismiss={this._toggleModalAlarmes(false)}
            containerClassName={classNames.modalContainer}
            scrollableContentClassName={classNames.modalScrollableContent}
        >
            <div className={classNames.modalHeader}>
                <h3>Alarmes actives</h3>
            </div>
            <div className={classNames.modalBody}>
                <DetailsListAlarme activerCreation={false} afficherAlarmesLieesASouhaits afficherAlarmesLieesACapsules afficherAlarmesLieesADemandes afficherAlarmesInactives={false} />
            </div>
            <div className={classNames.modalFooter}>
                <DefaultButton onClick={() => this.setState({ afficherModalAlarmes: false })} text="Fermer" />
            </div>
        </Modal>
    }
}